import { Button, Dialog, DialogTitle, Divider } from '@mui/material';
import { StyledDialogActions, StyledDialogContent } from 'scenes/guest/styles';

import Grid from 'components/core/Grid';
import Typography from '@mui/material/Typography';
import { useScreenWidth } from 'webHooks/useScreenWidth';

interface Props {
  isOpen: boolean;
  close: () => void;
  // TODO: improve typing
  dateRanges: any;
  description: any;
  isSpecialCircumstance: any;
  specialCircumstanceDescription: any;
}

export const CancellationPolicyDialog = ({
  isOpen,
  close,
  dateRanges,
  description,
  isSpecialCircumstance,
  specialCircumstanceDescription,
}: Props) => {
  const { isXs } = useScreenWidth();

  return (
    <Dialog open={isOpen} fullWidth maxWidth="sm" fullScreen={isXs} onClose={close}>
      <DialogTitle>Cancellation Policy</DialogTitle>
      <Divider />
      <StyledDialogContent>
        <Typography variant="body2">
          Cancellations have varying refund rules based on how far in advance the request is received before the
          check-in date.
        </Typography>
        <ul>
          {dateRanges.map((policy: any) => (
            <li key={policy.ID}>
              <Typography variant="body2">
                {policy.LABEL} : {policy.DESCRIPTION}
              </Typography>
            </li>
          ))}
        </ul>
        <Typography variant="body2">
          <strong>Guest Cancellation Policy</strong>
        </Typography>

        <Typography variant="body2">{description}</Typography>
        {isSpecialCircumstance ? (
          <Grid item xs={12}>
            <Typography variant="body2">
              <strong>Special Circumstances Cancellation Policy</strong>
              <br />
            </Typography>
            <Typography variant="body2">{specialCircumstanceDescription}</Typography>
          </Grid>
        ) : null}
      </StyledDialogContent>
      <StyledDialogActions className="centered">
        <Button color="primary" onClick={close}>
          Close
        </Button>
      </StyledDialogActions>
    </Dialog>
  );
};
